import { render, staticRenderFns } from "./PostDetails.vue?vue&type=template&id=c22c93fa&scoped=true"
import script from "./PostDetails.vue?vue&type=script&lang=ts"
export * from "./PostDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c22c93fa",
  null
  
)

export default component.exports